import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-name-stream',
    standalone: false,
    templateUrl: './name-stream.component.html',
    styleUrl: './name-stream.component.scss'
})
export class NameStreamComponent implements OnInit {
    readonly dialogRef = inject(MatDialogRef<NameStreamComponent>);
    readonly data = inject(MAT_DIALOG_DATA);
    private readonly formBuilder = inject(FormBuilder);
    private destroyRef = inject(DestroyRef);

    protected form!: FormGroup;

    public ngOnInit(): void {
        this.form = this.formBuilder.group({
            name: new FormControl<string>(
                `My new ${this.data.name} ${new Date().toLocaleString()}`,
                { nonNullable: true },
            ),
        });

        this.dialogRef.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();

                        if (this.form.invalid) {
                            this.form.markAllAsTouched();
                            return;
                        }

                        this.dialogRef.close(this.form.get('name')?.value);
                    }
                },
            });
    }

    protected close(): void {
        this.dialogRef.close();
    }

    protected start(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();

            return;
        }

        this.dialogRef.close(this.form.get('name')?.value);
    }

}
